
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const paymentDetails = {
  upiId: 'kol057235@tjsb',
  accountHolder: 'RAPID INTERNATIONAL MAGAZINE PRIVATE LIMITED',
  bankName: 'TJSB SAHAKARI BANK LTD',
  accountNumber: '120100000410996',
  ifsc: 'TJSB0000080',
  branch: 'Shahupuri Kolhapur',
};

// Update this path if your existing QR image has a different filename.
const QR_IMAGE = 'https://businessprideindia.com/bu_images/business-pride-upi-qr.png';

const contactDetails = {
  address:
    'Office no. 5 & 6, 3rd Floor, Star Tower, 1113/1, Panch Bunglow, Shahupuri, Kolhapur - 416001',
  email: 'info@businessprideindia.com',
  phone1: '+91 7013701057',
  phone2: '+91 9156440169',
  officePhone: '0231-2664275',
};

export default function Payments() {
  const [qrError, setQrError] = useState(false);

  const bankDetails = [
    ['Account Holder', paymentDetails.accountHolder],
    ['Bank Name', paymentDetails.bankName],
    ['Account Number', paymentDetails.accountNumber],
    ['IFSC Code', paymentDetails.ifsc],
    ['Branch', paymentDetails.branch],
  ];

  const unavailable = (value) => value || 'Not provided';

  return (
    <main className="container py-5">
      {/* Page heading */}
      <header className="text-center mb-5">
        <span className="badge rounded-pill bg-light text-primary px-3 py-2">
          PAYMENT INFORMATION
        </span>

        <h1 className="mt-3">Payments</h1>

        <p className="text-muted mx-auto" style={{ maxWidth: 650 }}>
          Find payment information for Business Pride India. For payment
          assistance, please contact our team using the details below.
        </p>
      </header>

      <div className="row g-4 justify-content-center">
        {/* UPI QR payment */}
        <div className="col-lg-5">
          <section className="card h-100 border-0 shadow-sm p-4 text-center">
            <div className="fs-1 mb-2" aria-hidden="true">
              <i className="bi bi-qr-code-scan" />
            </div>

            <h2 className="h4">Scan &amp; Pay</h2>

            <p className="text-muted small">
              Scan the official Business Pride India QR code using your
              preferred UPI payment application.
            </p>

            <div
              className="border rounded-3 p-3 mx-auto my-3"
              style={{ width: '100%', maxWidth: 300 }}
            >
              {!qrError ? (
                <img
                  src={QR_IMAGE}
                  alt="Business Pride India payment QR code"
                  className="img-fluid"
                  style={{
                    width: '100%',
                    maxWidth: 250,
                    objectFit: 'contain',
                  }}
                  onError={() => setQrError(true)}
                />
              ) : (
                <div className="py-4 text-muted">
                  <i className="bi bi-image fs-1 d-block mb-2" />
                  <p className="mb-1">QR code image unavailable.</p>
                  <small>
                    Check the image path in the Payments component.
                  </small>
                </div>
              )}
            </div>

            <div className="text-start mt-2">
              <p className="mb-1 small text-muted">UPI ID</p>
              <p className="fw-semibold text-break">
                {unavailable(paymentDetails.upiId)}
              </p>
            </div>

            <div className="alert alert-warning text-start small mb-0">
              <strong>Before paying:</strong> Confirm the recipient's name
              and payment amount in your UPI app. Do not proceed if the
              recipient cannot be verified.
            </div>
          </section>
        </div>

        {/* Bank transfer */}
        <div className="col-lg-5">
          <section className="card h-100 border-0 shadow-sm p-4">
            <div className="fs-1 mb-2 text-center" aria-hidden="true">
              <i className="bi bi-bank" />
            </div>

            <h2 className="h4 text-center">Bank Transfer</h2>

            <p className="text-muted small text-center">
              Bank transfer details will be published after the account
              information is provided and verified.
            </p>

            <div className="mt-3">
              {bankDetails.map(([label, value]) => (
                <div
                  key={label}
                  className="d-flex justify-content-between align-items-start gap-3 border-bottom py-3"
                >
                  <span className="small text-muted">{label}</span>
                  <span className="small fw-semibold text-end text-break">
                    {unavailable(value)}
                  </span>
                </div>
              ))}
            </div>

            <div className="alert alert-secondary small mt-4 mb-0">
              Bank details have not been supplied. Please contact our team
              before making a bank transfer.
            </div>
          </section>
        </div>
      </div>

      {/* Payment assistance and footer contacts */}
      <section className="card border-0 shadow-sm p-4 mt-4">
        <h2 className="h4 mb-2">Need Payment Assistance?</h2>

        <p className="text-muted">
          Contact Business Pride India for payment enquiries, transaction
          verification, or assistance with your payment.
        </p>

        <div className="row g-4">
          <div className="col-md-6">
            <h3 className="h6">
              <i className="bi bi-geo-alt me-2" aria-hidden="true" />
              Office Address
            </h3>
            <p className="small mb-0">{contactDetails.address}</p>
          </div>

          <div className="col-md-6">
            <h3 className="h6">
              <i className="bi bi-envelope me-2" aria-hidden="true" />
              Email
            </h3>
            <a href={`mailto:${contactDetails.email}`}>
              {contactDetails.email}
            </a>
          </div>

          <div className="col-md-4">
            <h3 className="h6">
              <i className="bi bi-telephone me-2" aria-hidden="true" />
              Contact 1
            </h3>
            <a href="tel:+917013701057">{contactDetails.phone1}</a>
          </div>

          <div className="col-md-4">
            <h3 className="h6">
              <i className="bi bi-telephone me-2" aria-hidden="true" />
              Contact 2
            </h3>
            <a href="tel:+919156440169">{contactDetails.phone2}</a>
          </div>

          <div className="col-md-4">
            <h3 className="h6">
              <i className="bi bi-headset me-2" aria-hidden="true" />
              Office / Toll-free listing
            </h3>
            <a href="tel:02312664275">{contactDetails.officePhone}</a>
          </div>
        </div>

        <div className="mt-4 d-flex flex-wrap gap-2">
          <a
            href={`mailto:${contactDetails.email}?subject=${encodeURIComponent(
              'Business Pride India Payment Enquiry'
            )}`}
            className="btn btn-primary"
          >
            <i className="bi bi-envelope me-2" aria-hidden="true" />
            Email for Payment Help
          </a>

          <Link to="/" className="btn btn-outline-secondary">
            Back to Home
          </Link>
        </div>
      </section>
    </main>
  );
}
